/* Horcery — reveal-on-scroll driver. Adds [data-hz-reveal-ready] so .hz-reveal
   elements start hidden, then reveals each as it enters view. Safety timeout
   reveals everything so content can never stay hidden. Respects reduced-motion. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.hz-reveal'));
    if (!els.length) return;
    document.documentElement.setAttribute('data-hz-reveal-ready', '');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    els.forEach(function (el) { io.observe(el); });
    // Safety: never leave anything hidden.
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2200);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
